import BrandsPage from './BrandsPage';

export default BrandsPage;
